import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { BUDGET_LINE_ITEMS } from "./apiRoutes";

const mutateAddLineItem = async ({
  budgetId,
  data,
}: {
  budgetId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.post(`${BUDGET_LINE_ITEMS(budgetId)}`, data);
};

const useAddLineItemMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      budgetId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddLineItem,
    ...queryParams,
  });

export default useAddLineItemMutation;
